import { Group, Title } from "@mantine/core"
import { Button, ToggleCollapse } from "@tfg/ui"
import React from "react"
import { useTranslation } from "react-i18next"

type Props = {
  titlePrefix: string
  openCollapse: () => void
  closeCollapse: () => void
  isCollapseOpened: boolean
  isOpen: boolean
  handleCreate: () => void
}

export const CardHeaderTitle = React.memo(
  ({
    titlePrefix,
    openCollapse,
    closeCollapse,
    isCollapseOpened,
    isOpen,
    handleCreate,
  }: Props) => {
    const { t } = useTranslation("organizationSettings")

    const handleToggle = () => {
      isCollapseOpened ? closeCollapse() : openCollapse()
    }

    return (
      <Group justify="space-between" w="100%">
        <Group
          justify="flex-start"
          onClick={handleToggle}
          style={{
            cursor: "pointer",
          }}
          w="100%"
        >
          <ToggleCollapse
            open={isCollapseOpened}
            toggle={handleToggle}
            iconSize={16}
            color="var(--mantine-color-gray-6)"
            pb={false}
          />
          <Title order={5}>
            {titlePrefix} {t("mapping.mapping")}
          </Title>
          {isOpen && (
            <Button
              onClick={(e) => {
                e.stopPropagation()
                handleCreate()
              }}
              style={{ marginLeft: "auto" }}
            >
              {t("mapping.create")}
            </Button>
          )}
        </Group>
      </Group>
    )
  }
)
